import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { appsAndFiltersPreviewCacheKey } from "./constants";
import type { AppsAndFiltersPreviewRequestPayload, GetAppsAndFiltersProps } from "./types";
import { isAppsAndFiltersPreview } from "./validators";

export const getAppsAndFiltersPreview = reactQueryPostWebsocketAdapter(
  appsAndFiltersPreviewCacheKey,
  async (
    signal,
    {
      appIds,
      appGroupId,
      timeout = 180000,
      jobToken,
      filters,
      estimated,
      totalOnly,
      includeAllApps,
      includeUsersWithoutApp,
      meta,
      sampleSizePercentage,
      forceRefresh,
      cancelExactStatsRequest,
    }: GetAppsAndFiltersProps
  ): Promise<{}> => {
    const payload: AppsAndFiltersPreviewRequestPayload = {
      app_ids: appIds,
      timeout,
      job_token: jobToken,
      filters,
      estimated,
      include_all_apps: includeAllApps,
      include_users_without_app: includeUsersWithoutApp,
      meta: meta,
      sample_size_percentage: sampleSizePercentage,
      cancel_exact_stats_request: cancelExactStatsRequest,
    };
    if (totalOnly) {
      // setting this at all will trigger regardless of value (BUG TO FIX)
      payload.total_segment_users_only = true;
    }

    return fetch(`/engagement/async/apps_and_filters_preview/${appGroupId}`, "POST", payload, {
      signal,
      headers: { "Force-Cache-Refresh": forceRefresh },
    });
  },
  isAppsAndFiltersPreview
);
